import { render, staticRenderFns } from "./adminban.vue?vue&type=template&id=ba421a5e&"
import script from "./adminban.vue?vue&type=script&lang=js&"
export * from "./adminban.vue?vue&type=script&lang=js&"
import style0 from "./adminban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports